/// <reference types="vite/client" />
import { wrapCreateRootRouteWithSentry } from "@sentry/tanstackstart-react";
import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  HeadContent,
  Outlet,
  Scripts,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "../components/ThemeProvider";
import globalCss from "./globals.css?url";
import "@fortawesome/fontawesome-free/css/all.min.css";

const RootLayout = () => {
  return (
    <html
      suppressHydrationWarning
      lang="en"
      className="dark h-full scroll-smooth"
    >
      <head>
        <HeadContent />
      </head>

      <body className="h-full antialiased">
        <ThemeProvider
          attribute="class"
          defaultTheme="dark"
          enableSystem
          disableTransitionOnChange
        >
          <ToastContainer position="bottom-right" />
          <Outlet />
          <TanStackRouterDevtools />
          <ReactQueryDevtools />
          <SpeedInsights />
          <Scripts />
        </ThemeProvider>
      </body>
    </html>
  );
};

export const Route = wrapCreateRootRouteWithSentry(createRootRouteWithContext)<{
  queryClient: QueryClient;
}>()({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      { title: "Backoffice Detentora Iniciador" },
    ],
    links: [
      { rel: "stylesheet", href: globalCss },
      { rel: "icon", href: "/favicon.ico" },
    ],
  }),
  component: RootLayout,
});
